import { render } from "./BaseHeading.vue?vue&type=template&id=57e1bff8"
import script from "./BaseHeading.vue?vue&type=script&lang=js"
export * from "./BaseHeading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__